import { KeyRound } from "lucide-react";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="border-t border-[#8A7563]/15 bg-[#FAF8F5]">
            <div className="mx-auto max-w-7xl px-6 py-16">
                <div className="grid grid-cols-1 gap-12 md:grid-cols-[1.2fr_1fr_1fr]">
                    <div>
                        <p className="font-display text-5xl font-semibold text-[#8A7563]">Gestion <span className="italic">Séjoura</span></p>
                        <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#8A7F72]">
                            Conciergerie de location. Gestion complète de votre résidence,
                            rémunérée uniquement à la performance.
                        </p>
                    </div>
                    <div>
                        <p className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-[#8A7563]">Contact</p>
                        <ul className="mt-5 space-y-3 text-sm text-[#5A4F44]">
                            <li>+1 438-397-6147</li>
                            <li>+1 263-382-6156</li>
                            <li>info@gestionsejoura.com</li>
                            <li><a href="https://gestionsejoura.com" data-testid="footer-domain-link" className="transition-colors hover:text-[#8A7563]">gestionsejoura.com</a></li>
                            <li>Montréal — Le Plateau · Mont-Tremblant</li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-[#8A7563]">Nos engagements</p>
                        <ul className="mt-5 space-y-3 text-sm text-[#5A4F44]">
                            <li className="flex items-center gap-2"><KeyRound size={13} className="text-[#8A7563]" /> Commission au résultat uniquement</li>
                            <li className="flex items-center gap-2"><KeyRound size={13} className="text-[#8A7563]" /> Aucun frais fixe, aucun engagement</li>
                            <li className="flex items-center gap-2"><KeyRound size={13} className="text-[#8A7563]" /> Étude de votre bien offerte</li>
                        </ul>
                    </div>
                </div>
                <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-[#2B2622]/10 pt-8 text-xs text-[#8A7F72] sm:flex-row sm:items-center">
                    <p>© 2026 Gestion Séjoura — Tous droits réservés.</p>
                    <p>Entreprise québécoise enregistrée au NEQ · Mentions légales & conditions sur demande.</p>
                </div>
            </div>
        </footer>
    );
}
